import VueGtag from 'vue-gtag';
import {Vue} from 'vue-property-decorator';
import router from '@/router';

Vue.use(
	VueGtag,
	{
		config: {
			id: 'UA-107124453-4'
		}
	},
	router
);
